import { gpAppInsights } from './telemetry';

export interface IGamePlanMetrics {
    trackEvent(name: string, properties?: { [key: string]: any }): void;
}

type EventProperties = { [key: string]: any };

class GamePlanMetrics implements IGamePlanMetrics {
    trackEvent(name: string, propertiesOrFunc?: EventProperties | (() => EventProperties)): void {
        const appInsights = gpAppInsights();

        if (appInsights && appInsights.trackEvent) {
            if (typeof propertiesOrFunc === 'function') {
                try {
                    appInsights.trackEvent({ name }, propertiesOrFunc());

                } catch (err) {

                }
            } else if (typeof propertiesOrFunc !== 'undefined') {
                appInsights.trackEvent({ name }, propertiesOrFunc);
            }
        }
    }
}

const globalMetrics = new GamePlanMetrics();

export function gpMetrics() {
    return globalMetrics;
}
